import BaseService from "../../../common/services/src/baseService";
import httpService from "../../../common/services/src/http/httpService";
import UrlService from '../../../common/services/src/url/urlService';


class LoginService  extends BaseService {

	constructor() {
		super("com.jacada.common.services.login.LoginService");
		this.redirectInterceptor = [];
		this.appRoles = {};		
		//one of these roles is sufficient to procceed login to the application
		this.appRoles["ADMIN_CONSOLE"] = ["ROLE_DESIGNER", "ROLE_ACCOUNT_ADMIN", 
											"ROLE_INTERACTION_ADMIN", "ROLE_BASE_SYSTEM_ADMIN",
											"ROLE_BASE_BI"];
		this.appRoles["DESIGNER"] = ['ROLE_DESIGNER'];
		this.appRoles["AGENT"] = ['ROLE_AGENT', 'ROLE_CUSTOM'];
		this.accountId = null;
		this.username = null;
	}

	auth(accountId, username, password, appKey, loginParams) {
		return httpService.execute({
			method: 'POST',
			// path: 'interact/authenticate/login',
			url: '/interact/authenticate/login',
			headers: {
				'Environment-Name': 'Dev',
				'User-Id': btoa(username),
				'User-Password': btoa(password),
				'Tenant-Id': accountId,
				'Application-Key': appKey,
				'Target-Application' : this.getTargetApplication(),
				'Login-Params' : btoa(JSON.stringify(loginParams))
			}
		});		
	}

	validateLoginParameters(appKey){
		return httpService.execute({
			method: 'POST',
			url: '/interact/authenticate/validate/loginParams',
			headers: {
				'Environment-Name': 'Dev',
				'Tenant-Id': this.accountId,
				'Application-Key': this.getTargetApplication(),
				//'Target-Application' : this.getTargetApplication(),
				'Content-Type' : 'application/json'
			}
		});
	}

	validateMFAcode(appKey, mfaCode){
		return httpService.execute({
			method: 'POST',
			url: '/interact/authenticate/mfachallenge',
			headers: {
				'Environment-Name': 'Dev',
				'MFA-Challenge': mfaCode,
				'Tenant-Id': this.accountId,
				'Application-Key': appKey,
				'Target-Application' : this.getTargetApplication()
			}
		});
	}

	getMFAQRcode(appKey){
		console.log("LoginService.getMFAQRcode " + this.accountId);
		return httpService.execute({
			method: 'GET',
			url: '/interact/authenticate/qrcode',
			headers: {
				'Environment-Name': 'Dev',
				'Tenant-Id': this.accountId,
				'Application-Key': appKey,
				'Target-Application' : this.getTargetApplication()
			}
		});
	}

	getAuthLink(accountId, appKey) {

		return httpService.execute({
			method: 'GET',
			path: 'interact/authenticate/settings',
			headers: {
				'Tenant-Id': accountId,
				'Application-Key': appKey
			},
			queryParams: {
				target: this.getTargetApplication()
			}
		});
	}

	resetPassword(accountId, appKey, password, verificationKey) {
		var data = {
			'password': password,
			'key': verificationKey
		};

		return httpService.execute({
			method: 'POST',
			path: 'interact/recovery',
			headers: {
				'Content-Type': 'application/json',
				'Tenant-Id': accountId,
				'Application-Key': appKey
			},
			data: JSON.stringify(data)
		});
	}

	recoverPassword(accountId, appKey, email) {

		return httpService.execute({
			method: 'GET',
			path: 'interact/recovery/' + accountId + '?&email=' + email + '&tenantName=' + accountId,
			headers: {
				'Tenant-Id': accountId,
				'Application-Key': appKey,
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Cache-Control': 'no-cache'
			}
		});
	}

	keepLoginInfo(username, accountId){
		this.username = username;
		this.accountId = accountId;
	}

	updateLoginData(accessToken, userId, roles){
		// AGENT APP
		window.localStorage.setItem(this.getAgentStorageName('agentId', this.accountId), this.username);
		window.localStorage.setItem(this.getAgentStorageName('userRoles', this.accountId), roles);

		// ADMIN
		document.cookie = 'username=' + encodeURIComponent(this.username) + ';path=/;'; // Encode the text since it may include special chars
		document.cookie = 'accountId=' + this.accountId + ';path=/';

		// DESIGNER
		window.sessionStorage.setItem(this.getDesignerStorageName('tenant'), this.accountId);
		window.sessionStorage.setItem(this.getDesignerStorageName('username'), this.username);
		window.sessionStorage.setItem(this.getDesignerStorageName('userId'), userId);

		window.localStorage.setItem(this.getDesignerStorageName(this.username, this.accountId, 'userLastActive', true), +new Date());
	}

	getDesignerStorageName(key, username, accountId) {
		if (username) {
			return username + "_" + accountId + "_interactDesigner_" + key;
		}

		return "interactDesigner_" + key;
	}

	getAgentStorageName(key, accountId) {
		return key + accountId;
	}

	redirectToApp() {
		let redirectUrl = UrlService.getSearchParam('originalPath');
		if (!window.location.origin) {
			window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
		}

		if(!redirectUrl) {
			redirectUrl = window.location.origin + "/admin/main/" + this.accountId;
		}

		for(let interceptor of this.redirectInterceptor) {
			redirectUrl = interceptor(redirectUrl);
		}

		window.location.assign(redirectUrl);
	}

	addRedirectInterceptor(interceptor) {
		this.redirectInterceptor.push(interceptor);
	}

	getTargetApplication() {
		let originalPath = UrlService.getSearchParam('originalPath');

		if(!originalPath){
			return 'ADMIN_CONSOLE';
		}

		if(originalPath.indexOf('designer') > -1) {
			return 'DESIGNER';
		}else if((originalPath.indexOf('admin') > -1)) {
			return 'ADMIN_CONSOLE';
		}else {
			return UrlService.getSearchParamsFromUrl(decodeURIComponent(originalPath)).get('appkey');
		}
	}

	isTargetAgentApp() {
		let target = this.getTargetApplication();
		return target != 'DESIGNER' && target != 'ADMIN_CONSOLE';
	}

	isAuthorized(roles) {		
		if (!roles) {
			return false;
		}
		let target = this.getTargetApplication();
		if (target != 'DESIGNER' && target != 'ADMIN_CONSOLE') {
			target = "AGENT"; //any other application will be an appkey, AGENT_ROLE is the minimum suffiecient role for any app
		}
		for (var i=0; i < this.appRoles[target + ''].length; i++ ) {			
			if (roles.indexOf(this.appRoles[target + ''][i]) > -1) {
				return true;
			}
		}
		
		return false;

	}

	validateAuth0Account(appKey, accountId) {
		return httpService.execute({
			method: 'GET',
			url: '/interact/authenticate/auth0Account/validate',
			headers: {
				'Environment-Name': 'Dev',
				'Tenant-Id': accountId,
				'Application-Key': appKey,
				'Content-Type' : 'application/json'
			}
		});
	}

	redirectToAuth0LoginPage(accountId) {
		this.keepLoginInfo(null, accountId)
		this.redirectToApp();
	}
}

export default new LoginService();




// WEBPACK FOOTER //
// ./src/services/LoginService.js